import { Alert } from '@design-system';
import { customsCodeIsRequired } from '@utils/address';
import { Trans, useTranslation } from 'next-i18next';

import { GeneratedAddress } from '../../../../types/generated';

interface Props {
  onClick: () => void;
  address?: GeneratedAddress;
}

export const CustomsCode = ({ address, onClick }: Props) => {
  const { t } = useTranslation('product');

  const isCustomsCodeMissing =
    !address?.customsCode && customsCodeIsRequired(address?.countryCode);

  if (!isCustomsCodeMissing) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <Alert status="error">
        <Trans i18nKey="drawers.review.customs.buttonText" t={t}>
          In order to ship to {address?.countryName}, please
          <button className="hyperlink" onClick={onClick} type="button">
            add customs details
          </button>
          .
        </Trans>
      </Alert>
    </div>
  );
};
